var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:{ show: _vm.is_loaded },style:(_vm.style),attrs:{"src":_vm.src,"alt":_vm.alt},on:{"load":_vm.setVisible}})
}
var staticRenderFns = []

export { render, staticRenderFns }